<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="board-list">
				<h3>자주하는 질문</h3>
				<div class="search" >
					<el-input v-model="search" @change="changeSearch" placeholder="질문을 검색합니다." suffix-icon="el-icon-search"></el-input>
				</div>
				
				<div class="category-wrap" v-if="!isMobile">
					<div class="category-item"  :class="{ 'selected': cate_id == item.id }" v-for="(item, index) in cateNameList" :key="index" @click="onCateId(item.id)" >
						{{item.cate_name}}
					</div>
				
					<router-link to="/addService" class="category-item link">
						<div>
							<strong>
								부가서비스<img src="../../assets/arrow.svg" alt="">
							</strong>
							<span>개인</span>	
						</div>
					</router-link>
					<router-link to="/payGuide" class="category-item link">
						<div>
							<strong>
								대리결제<img src="../../assets/arrow.svg" alt="">
							</strong>
							<span>사업자회원</span>	
						</div>
					</router-link>
					<router-link to="/inventoryGuide" class="category-item link">
						<div>
							<strong>
								재고보관<img src="../../assets/arrow.svg" alt="">
							</strong>
							<span>사업자회원</span>	
						</div>
					</router-link>
					<router-link to="/bizAddService" class="category-item link">
						<div>
							<strong>
								부가서비스<img src="../../assets/arrow.svg" alt="">
							</strong>
							<span>사업자회원</span>	
						</div>
					</router-link>
				</div>
				<div v-else>
					<div class="category-wrap" >
						<div class="item" :class="{ 'selected': cate_id == item.id }" v-for="(item, index) in cateNameList" :key="index" @click="onCateId(item.id)" >
							{{item.cate_name}}
						</div>
					
					</div>
					
					<div class="wrap" >
						<router-link to="/addService" class="wrap-item link">
							<div>
								<strong>
									부가서비스
								</strong>
								<span>개인</span>  <img src="../../assets/arrow.svg" alt="">
							</div>
						</router-link>
						<router-link to="/payGuide" class="wrap-item link">
							<div>
								<strong>
									대리결제
								</strong>
								<span>사업자</span>	<img src="../../assets/arrow.svg" alt="">
							</div>
						</router-link>
						<router-link to="/inventoryGuide" class="wrap-item link">
							<div>
								<strong>
									재고보관
								</strong>
								<span>사업자</span>	<img src="../../assets/arrow.svg" alt="">
							</div>
						</router-link>
						<router-link to="/bizAddService" class="wrap-item link">
							<div>
								<strong>
									부가서비스
								</strong>
								<span>사업자</span>	<img src="../../assets/arrow.svg" alt="">
							</div>
						</router-link>
					</div>
				</div>
				
				<div class="list-top">
					<h4>
						전체
						<span>{{total}}개</span>
					</h4>
				</div>
				<el-table v-if="!isMobile"
				  :data="tableData"
				  stripe @row-click="clickDetails"
				  style="width: 100%">
					<el-table-column
					  prop="cate_name" 
					  label="카테고리"
					  width="180">
					</el-table-column>
					<el-table-column
					  prop="title"
					  label="제목">
					</el-table-column>
					<el-table-column
						prop="createtime"
						label="작성일"
						width="180">
					</el-table-column>
				</el-table>
				<el-table v-else
				  :data="tableData" 
				  stripe @row-click="clickDetails"
				  style="padding: 0 10px;width: 100%">		
					<el-table-column
					  prop="title"
					  label="제목">
					</el-table-column>
				</el-table>
				<div class="page">
					<el-pagination
						layout="prev, pager, next" :page-size="20"
						:total="total"  @current-change="handleCurrentChange">
					</el-pagination>
				</div>		
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request';
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return{
				loading: true,
				cate_id:'',
				search: '',
				total:0,
				page:1,
				tableData: [],
				cateNameList:[]
			}
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			}
		},
		created() {
			
		},
		mounted(){
			this.getCateName()
					
			this.getList()
		},
		methods: {
			onCateId(id){
				console.log(id,"导航分类id")
				this.cate_id = id
				this.page = 1,
				this.getList()
				
			},
			clickDetails(row, column, event){
				console.log(row,1)
				console.log(column,1)
				console.log(event,3)
				
				this.$router.push(`/questionDetails/${row.id}`)
				
			},
			getCateName(){
				request.post('/Question/getCateName',{}
				).then(res => {
					
					if(res.code ==1){
						console.log(res.data,"1111")
						this.cateNameList= res.data
						
					}
						
				});
			},
			getList(){
				this.loading = true
				request.post('/Question/getCustomerQuestion',
					{
						search:this.search,
						page:this.page,
						cate_id:this.cate_id
					}
				).then(res => {
					this.loading = false
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.total
						this.tableData= res.data.data//this.tableData.concat(res.data.data)
						
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			onNav(url){
				this.$router.push(url)
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			changeSearch(value){
				console.log(value,333333333333)
				this.search = value
				this.cate_id = ''
				this.page = 1
				this.getList()
			}
			
		}
	}
</script>

<style scoped>
	.board-list h3{
		text-align: center;
		font-size: 45px;
		font-weight: bold;
		color: var(--frontground-color);
		padding: 0;
		margin: 0 0 50px;	
	}
	.search{
		padding: 0 300px;
		margin-bottom: 100px;
	}
	.category-wrap{
		margin-bottom: 100px;
		display: flex;
		flex-wrap:wrap;
		justify-content: space-between;
	}
	.category-wrap .category-item{
		width: 190px;
		height: 160px;
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		color: #000;
		border-radius: 20px;
		border: 1px solid #dbdbdb;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		text-decoration: none;
		padding: 0 20px;
		word-break: keep-all;
		margin-bottom: 20px;
		cursor: pointer;
	}
	.category-wrap .selected {
	    color: var(--main-color);
	    border-color: var(--main-color);
	    box-shadow: 0px 0px 20px rgba(247, 148, 29, 0.13);
	}
	.category-wrap .link{
		box-shadow: none !important;
		background-color: var(--secondary-color);
		border-color: var(--secondary-color);
		color: #fff;
	}
	.category-wrap .link span {
	    display: block;
	    font-size: 20px;
	    font-weight: normal;
	}
	.list-top{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 40px;
	}
	.list-top h4 {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0;
	}
	.list-top h4 span {
	    color: var(--main-color);
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.board-list h3{
			padding-top: 20px;
		}
		.search{
			padding: 0 20px;
			margin-bottom: 50px;	
		}
		.category-wrap{
			justify-content: start;
			padding: 0 10px;
			margin-bottom: 0;
		}
		.category-wrap .item{
			padding: 8px 8px 7px;
			font-size: 14px;
			font-weight: bold;
			color: #303030;
			border-radius: 10px;
			border: 1px solid var(--border-color);
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			text-decoration: none;
			word-break: keep-all;
			margin: 0 10px 10px 0;
		}
		.category-wrap .selected {
		    color: var(--main-color);
		    border-color: var(--main-color);
		    box-shadow: none;
		}
		.category-wrap .link span {
		    display:inline;
			font-size: 14px;
			font-weight: normal;
		}
		.wrap{
			display: flex;justify-content: space-between;flex-wrap:wrap;
			padding: 0 10px;
		}
		.wrap-item{
			text-align: center;
			font-size: 14px;
			font-weight: bold;
			color: #000;
			border-radius: 10px;
			width: 48%;
			height: 50px;
			border: 1px solid #dbdbdb;
			background: #fff;
			display: flex;
			align-items: center;
			justify-content: center;
			text-decoration: none;
			padding: 8px 8px 7px;
			word-break: keep-all;
			margin-bottom: 10px;
			cursor: pointer;
		}
		.wrap-item.link{
			box-shadow: none !important;
			background-color: var(--secondary-color);
			border-color: var(--secondary-color);
			color: #fff;
		}
		.wrap-item.link span {
		    color: rgba(255, 255, 255, 0.7);
		    font-weight: normal;
		}
		.list-top h4 {
			font-size: 24px;
			padding: 0 10px;
		}
		
	}
</style>